/* eslint-disable react/jsx-props-no-spreading */
import Button, { ButtonProps } from 'components/button/Button';
import { ReactNode } from 'react';

import {
  BottomLine,
  ButtonsWrapper,
  Content,
  Cover,
  Dash,
  HalfleftLogo,
  HalfRightLogo,
  Image,
  Info,
  Text,
  Title,
  TitleText,
  TitleWrapper,
  TopLine,
  WhiteLine,
  Wrapper,
} from './LandingHero.styles';

export interface LandingHeroProps {
  altCover?: string;
  image: string;
  title: string;
  noDash?: boolean;
  text?: string;
  buttons?: ButtonProps[];
  children?: ReactNode;
  size?: 'md' | 'xl';
}

const LandingHero = ({
  altCover,
  image,
  title,
  noDash,
  text,
  buttons,
  children,
  size = 'xl',
}: LandingHeroProps): JSX.Element => {
  return (
    <>
      <TopLine />
      <Wrapper size={size}>
        <Cover />
        <Image
          src={image}
          fill
          style={{ objectFit: 'cover', objectPosition: 'center' }}
          priority // Ensures the image loads faster
          alt={altCover}
        />
        <HalfleftLogo src="/halfLogo2.png" size={size} alt="Half right gear" />
        <HalfRightLogo
          src="/halfLogo1.png"
          size={size}
          alt="Half left ship's pedal"
        />
        <Content>
          <Info size={size}>
            <TitleWrapper>
              <Title>
                <TitleText>{title}</TitleText>
                <Dash noDash={noDash} />
              </Title>
              <WhiteLine />
            </TitleWrapper>
            {text && <Text>{text}</Text>}
            {children}
            {buttons && (
              <ButtonsWrapper>
                {buttons.map((button) => (
                  <Button key={button.text} {...button} />
                ))}
              </ButtonsWrapper>
            )}
          </Info>
        </Content>
      </Wrapper>
      <BottomLine />
    </>
  );
};

export default LandingHero;
